import { env } from '@ui/environment';
import axios from 'axios';
export const axiosInstance = axios.create({
    baseURL: env.PUBLIC_CORE_API_BASE_URL
});
export function AxiosInstance(param) {
    let { children } = param;
    return children;
}
export { axiosInstance as axios };
